"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FocusDelegate = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
// This is a bit naive, but it will honestly work for quite a while.
// if this Menu component is ever used for LONG lists of stuff, we might want to
// introduce more of a LinkedHashMap kind of structure.
function getIt(arr, search, delta) {
  for (let index = 0; index < arr.length; index++) {
    const current = arr[index];
    if (current === search) {
      const nextIndex = index + delta;
      if (nextIndex < 0 || nextIndex >= arr.length) {
        break;
      }
      return arr[nextIndex];
    }
  }
  return null;
}
class FocusDelegate {
  focusables = [];
  setFocusables(withinElement) {
    this.focusables = (0, _lodestarUtils.getKeyboardFocusableElementsIn)(withinElement);
  }
  addPortalFocusables(portalId, afterElem) {
    const portal = document.getElementById(portalId);
    if (portal) {
      const focusablesFromPortal = (0, _lodestarUtils.getKeyboardFocusableElementsIn)(portal);

      // Adds the new focusables after a secified element
      if (afterElem) {
        const afterElemIndex = this.focusables.indexOf(afterElem);

        // put the new focusables after the afterElem
        this.focusables = this.focusables.slice(0, afterElemIndex + 1).concat(focusablesFromPortal).concat(this.focusables.slice(afterElemIndex + 1));
      } else {
        this.focusables = this.focusables.concat(focusablesFromPortal);
      }
    }
  }

  /** Returns the element visually above the given one, or `null` for none. */
  getElementAbove(element) {
    return getIt(this.focusables, element, -1);
  }

  /** Returns the element visually below the given one, or `null` for none. */
  getElementBelow(element) {
    return getIt(this.focusables, element, 1);
  }

  /** Returns the first element, or `null` for none. */
  getFirstElement() {
    return this.focusables[0] || null;
  }

  /** Returns the last element, or `null` for none. */
  getLastElement() {
    return this.focusables[this.focusables.length - 1] || null;
  }
  getFirstEnabledElement() {
    return this.focusables.find(element => {
      return (!element.ariaDisabled || element.ariaDisabled === "false") && !element.disabled;
    }) || null;
  }
  focusablesInclude(elem) {
    return this.focusables.includes(elem);
  }
}
exports.FocusDelegate = FocusDelegate;
//# sourceMappingURL=FocusDelegate.js.map